const SALES_ORDER_INITIAL_FILTERS = {
  customerName: null,
  customerDocumentNumber: null,
  salesOrderNumber: null,
  quoteNumber: null,
  orderNumber: null,
  headerStatus: null,
  initDate: null,
  endDate: null,
  pageNumber: 1,
  pageSize: 10,
}

export function buildSalesOrderSearchPayload(filters) {
  const hasDateRange = filters.initDate || filters.endDate
  const hasHeaderStatus = filters.headerStatus?.length > 0
  const hasActiveFilters =
    filters.customerName ||
    filters.customerDocumentNumber ||
    filters.salesOrderNumber ||
    filters.quoteNumber ||
    filters.orderNumber ||
    hasHeaderStatus ||
    hasDateRange
  const toDateOnly = dateStr => (dateStr ? dateStr.substring(0, 10) : undefined)
  const warehouseIds =
    hasActiveFilters || !filters.warehouseId ? undefined : [filters.warehouseId]

  return {
    pageNumber: filters.pageNumber,
    pageSize: filters.pageSize,
    companyId: filters.companyId,
    warehouseIds,
    customerName: filters.customerName || undefined,
    customerNumber: filters.customerDocumentNumber || undefined,
    salesOrderNumber: filters.salesOrderNumber || undefined,
    quoteNumber: filters.quoteNumber || undefined,
    orderNumber: filters.orderNumber || undefined,
    headerStatusIds: hasHeaderStatus ? filters.headerStatus : undefined,
    dateStart: toDateOnly(filters.initDate),
    dateEnd: toDateOnly(filters.endDate),
    ignoreDateFilter: hasDateRange ? undefined : true,
    origin: 'va',
  }
}

export const salesOrderFilterFields = [
  {
    key: 'salesOrderNumber',
    i18nKey: 'SEARCH_QUOTATION_T.NUMBER_SALE_ORDER_LABEL',
    testId: 'input-salesorderid-filter',
  },
  {
    key: 'quoteNumber',
    i18nKey: 'SEARCH_QUOTATION_T.NUMBER_QUOTATION_LABEL',
    testId: 'input-quoteid-filter',
  },
  {
    key: 'orderNumber',
    i18nKey: 'SEARCH_QUOTATION_T.NUMBER_ORDER_LABEL',
    testId: 'input-orderid-filter',
  },
]

export const salesOrderDocumentsSearchConfig = {
  initialFilters: SALES_ORDER_INITIAL_FILTERS,
  buildPayload: buildSalesOrderSearchPayload,
}
